module.exports = __webpack_public_path__ + "static/images/monet/search_field.svg";